import React from 'react';

export default function BehavioralCard({ metrics }) {
  const { newVsReturning, groupVsSolo } = metrics || {};

  const newCount = newVsReturning?.new || 0;
  const returningCount = newVsReturning?.returning || 0;
  const totalVisitors = newCount + returningCount;

  const groupCount = groupVsSolo?.group || 0;
  const soloCount = groupVsSolo?.solo || 0;
  const totalCheckins = groupCount + soloCount;

  const getPercent = (value, total) => {
    if (total === 0) return 0;
    return Math.round((value / total) * 100);
  };

  return (
    <div className="bg-white rounded-lg shadow p-6">
      <h3 className="text-sm font-medium text-gray-500 mb-4">Visitor Behavior</h3>

      <div className="space-y-6">
        {/* New vs Returning */}
        <div>
          <p className="text-xs font-medium text-gray-700 mb-3">New vs Returning Visitors</p>
          <div className="flex h-4 rounded-full overflow-hidden bg-gray-100">
            {totalVisitors > 0 && (
              <>
                <div
                  className="bg-blue-500 transition-all"
                  style={{ width: `${getPercent(newCount, totalVisitors)}%` }}
                  title={`New: ${newCount}`}
                />
                <div
                  className="bg-green-500 transition-all"
                  style={{ width: `${getPercent(returningCount, totalVisitors)}%` }}
                  title={`Returning: ${returningCount}`}
                />
              </>
            )}
          </div>
          <div className="flex justify-between mt-2 text-xs">
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-blue-500" />
              <span className="text-gray-600">New: {newCount} ({getPercent(newCount, totalVisitors)}%)</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-green-500" />
              <span className="text-gray-600">Returning: {returningCount} ({getPercent(returningCount, totalVisitors)}%)</span>
            </div>
          </div>
          <p className="text-xs text-gray-400 mt-1">
            Returning = visited your listing before this passport
          </p>
        </div>

        {/* Group vs Solo */}
        <div>
          <p className="text-xs font-medium text-gray-700 mb-3">Group vs Solo Check-ins</p>
          <div className="flex h-4 rounded-full overflow-hidden bg-gray-100">
            {totalCheckins > 0 && (
              <>
                <div
                  className="bg-purple-500 transition-all"
                  style={{ width: `${getPercent(groupCount, totalCheckins)}%` }}
                  title={`Group: ${groupCount}`}
                />
                <div
                  className="bg-amber-500 transition-all"
                  style={{ width: `${getPercent(soloCount, totalCheckins)}%` }}
                  title={`Solo: ${soloCount}`}
                />
              </>
            )}
          </div>
          <div className="flex justify-between mt-2 text-xs">
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-purple-500" />
              <span className="text-gray-600">Group: {groupCount} ({getPercent(groupCount, totalCheckins)}%)</span>
            </div>
            <div className="flex items-center gap-1">
              <span className="w-2 h-2 rounded-full bg-amber-500" />
              <span className="text-gray-600">Solo: {soloCount} ({getPercent(soloCount, totalCheckins)}%)</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
